import React from "react";
import { SubscriptionView } from "../components/SubscriptionView";

const Purchase: React.FC = () => {
  return <SubscriptionView isEmbedded={false} />;
};

export default Purchase;

